import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { UseHeader } from '@cps'
import { activityMobx, memberMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import codeSendBgImg from '@img/mkt/codeSendBg.jpeg'
import './index.scss'
interface IProps extends IPage, RouteComponentProps { }
const ActivityList: FC<IProps> = () => {
  const history = useHistoryNew()
  const { lotteryList, getLuckyActive } = activityMobx
  const handleGo = (id: string) => {
    history.push(`/luckyDraw/detail/${id}`)
  }
  const goBack = () => {
    mktController.goBack(history)
  }
  useIonViewWillEnter(() => {
    getLuckyActive()
  }, [])
  return (
    <IonPage className='active-list-page'>
      <UseHeader title={i18n.t('mkt.activity.title')} onBack={goBack}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          {
            lotteryList.map((item: any) => {
              return (
                <div
                  className='info'
                  key={item.activityId}
                  onClick={(e: any) => {
                    e.stopPropagation()
                    handleGo(item.activityId)
                  }}
                >
                  <div className='info-img' style={{ backgroundImage: `url(${item.extra?.interfaceDisplay || codeSendBgImg})` }}></div>
                  <div className='info-title'>{item.activityName}</div>
                </div>
              )
            })
          }
        </div>
      </IonContent>
    </IonPage>
  )
}
export default observer(ActivityList)
